import React from 'react';
import DropDown from '../dropdown';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTextResources } from '../../../language';
import { EntityType as EntityTypes } from '../constants';

const EntityTypesDropDown = ({ entityTypeIds = [], ...rest }) => {
  const text = useTextResources();

  //If provided with entityIds, use only those. Otherwise, use the entire Enum
  const options = entityTypeIds.length
    ? _.pickBy(EntityTypes, (key) => entityTypeIds.includes(key))
    : EntityTypes;

  const data = _.map(options, (key, value) => {
    return {
      text: text(value),
      value: key,
    };
  });

  return (
    <DropDown
      textField='text'
      valueField='value'
      data={data}
      {...rest}
    />
  );
};

EntityTypesDropDown.propTypes = {
  entityTypeIds: PropTypes.array,
  onChange: PropTypes.func,
};

export default EntityTypesDropDown;
